import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FRONT_CONTENT_NAMES } from 'app/front-pages/shared/constants/front-content-names';
import { PagesFrontMenuEntry } from 'app/front-pages/shared/interfaces/pages-front-menu-entry.interface';

import { AccountService, ContentService } from 'app/shared/services';

@Component({
  selector: 'app-front-header',
  templateUrl: './front-header.component.html',
  styleUrls: ['./front-header.component.css']
})
export class FrontHeaderComponent implements OnInit {

  isSticky: boolean = false;

  @ViewChild('navbar') navbarElement: ElementRef;

  @HostListener('window:scroll', [])
  onScroll() {
    const scrollTop = window.scrollY;
    if (scrollTop > 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }


  menuIsCollapsed = true;

  loggedIn: boolean;

  roles: any = new Array();
  userMenuEntries: PagesFrontMenuEntry[];
  userName = 'default';

  menuEntries: PagesFrontMenuEntry[] = [
    {
      title: 'Home',
      menuName: FRONT_CONTENT_NAMES.HOME
    },
    {
      title: 'About_Single_Window',
      menuName: FRONT_CONTENT_NAMES.About_Single_Window
    },
    {
      title: 'Services',
      menuName: FRONT_CONTENT_NAMES.Services
    },
    {
      title: 'Support_and_Assistance',
      menuName: FRONT_CONTENT_NAMES.Support_and_Assistance
    },
 
  ];


  translate:TranslateService;
  constructor(
    private contentService: ContentService,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private translateService:TranslateService
  ) {
    this.translate=translateService;

  }

  ngOnInit() {
  
    if (this.loggedIn) {
      this.accountService.getDisplayName().subscribe(result => {
        if (result) {
          this.userName = result;
        }
      });
    }
    this.generateMenu();

    this.route.queryParams.subscribe(params => {
      const scrollPosition = params['scrollPosition'];
      if (scrollPosition) {
        window.scrollTo({ top: scrollPosition });
      }
    });
  }


  private generateMenu() {
    this.setMenuEntries();
  }

  private setMenuEntries() {
    // Populates the front pages menu entry list

    this.userMenuEntries = [];
    for (const menuEntry of this.menuEntries) {
      const menuName = menuEntry.menuName;
      
        this.userMenuEntries.push(
          this.menuEntries.find(
            newMenuEntry => newMenuEntry.menuName === menuName
          )
        );
      
    }
  }

  navigateToMyAccountPage() {
    this.contentService.setContent(FRONT_CONTENT_NAMES.ACCOUNT_HOME);
  }

  changelanguage(){
    if(this.translate.currentLang=='ar')
    {
    this.translate.use('en');
    this.translate.currentLang='en';
    localStorage.setItem('currentLanguage', 'en');

    }
    else{
      this.translate.use('ar');
      this.translate.currentLang='ar';
      localStorage.setItem('currentLanguage', 'ar');

    }
    setTimeout(()=>{
      window.location.reload();
    }, 5);
  }

  setContent(contentName: string) {
 
    //routing to the pages name
     this.router.navigate([`/${contentName}`]);
  }



  login() {
 

    this.router.navigate(['/auth/login']);
  }



}



// WEBPACK FOOTER //
// ./src/app/front-pages/Layouts/front-header/front-header.component.ts